import { useEffect, useState } from "react";
import useNavigation from "../../hooks/use-navigation";

const TOAST_MS = 3000;

// A toast one screen hands to the next through the history entry state (navigate(to, { state: { toast } })).
// Neutral, bottom centre, 3 s (design-system: Toast); shown once — the state is dropped at once.
function FlashToast() {
  const { locationState, clearLocationState } = useNavigation();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!locationState?.toast) return;
    setMessage(locationState.toast);
    clearLocationState?.();
  }, [locationState, clearLocationState]);

  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => setMessage(null), TOAST_MS);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;
  return (
    <div
      role="status"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 rounded-xl bg-[#14171a] px-4 py-3 text-sm text-white shadow-lg"
    >
      {message}
    </div>
  );
}

export default FlashToast;
